var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRupee(_ref, svgRef) {
  var _ref2;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 75,
    viewBox: "0 0 56 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M26.2463 74.0293C18.9888 74.0293 13.443 72.1122 9.60885 68.2781C5.7747 64.3755 3.85763 58.6242 3.85763 51.0244L3.85763 37.0572C10.225 37.0572 15.2916 36.886 19.0573 36.5437C22.8229 36.1329 25.5959 35.414 27.376 34.387C29.2246 33.2915 30.4228 31.6141 30.9705 29.3547C31.5867 27.0953 31.8948 24.0827 31.8948 20.317V5.83631L44.9377 5.83631V20.0089C44.9377 24.4593 44.4585 28.3619 43.4999 31.7168C42.5414 35.0032 40.9667 37.7419 38.7757 39.9328C36.6532 42.0553 33.7776 43.6642 30.1489 44.7597C26.5202 45.7867 22.0698 46.3002 16.7979 46.3002V52.5649C16.7979 55.7829 17.4825 58.4188 18.8519 60.4728C20.2212 62.4584 22.6175 63.4512 26.0409 63.4512C29.3273 63.4512 31.6552 62.4926 33.0245 60.5755C34.3938 58.6585 35.0785 56.0225 35.0785 52.6676H47.8133C47.6764 59.4458 45.7936 64.7178 42.1648 68.4835C38.5361 72.1807 33.2299 74.0293 26.2463 74.0293ZM0.776624 27.6088V18.7765H55.7213V27.6088H0.776624ZM0.776624 10.4578V0.906696L55.7213 0.906696V10.4578L0.776624 10.4578Z",
    fill: "#EAEEED",
    style: (_ref2 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref2, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref2, "fillOpacity", 1), _ref2)
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupee);
export default __webpack_public_path__ + "static/media/rupee.fd06f54f.svg";
export { ForwardRef as ReactComponent };